module.exports = __webpack_public_path__ + "img/22.0f7eae28.jpg";